import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/360_F_470299797_UD0eoVMMSUbHCcNJCdv2t8B2g1GVqYgs.jpg";
import projImg2 from "../assets/img/project-net-mongodb-crud.jpg";
import projImg3 from "../assets/img/project-fake-news-detection.PNG";
import projImg4 from "../assets/img/project-audio-player.PNG";
import colorSharp2 from "../assets/img/color-sharp2.png";
import colorSharp from "../assets/img/color-sharp.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { ArrowRightCircle } from 'react-bootstrap-icons';

export const Projects = () => {

  const projects = [
    {
      title: "Library App - .NET MVC",
      description: "A library management application built with .NET MVC, allowing users to borrow, return, and manage books efficiently.",
      imgUrl: projImg1,
    },
    {
      title: "Fake News Detection AI – NLP & Python",
      description: "A Python Flask-based NLP project that analyzes user-submitted news using SVM, LSTM, and Random Forest models to detect whether it is true or false.",
      imgUrl: projImg3,
    },
    {
      title: "Desktop Audio Player - Python",
      description: "A desktop application built with Python that allows you to play music on your computer.",
      imgUrl: projImg4,
    },
    {
      title: ".NET & MongoDB CRUD",
      description: "A .NET-based project demonstrating basic CRUD operations (Create, Read, Update, Delete) with MongoDB.",
      imgUrl: projImg2,
    },
    {
      title: "QR Code Generator",
      description: "A simple Python application that quickly generates QR codes from user-provided data.",
      imgUrl: projImg1,
    },
    {
      title: "Address Book - .NET Web API",
      description:"An address book application built with .NET Web API and PostgreSQL, containerized with Docker, and deployed on AWS ECS.",
      imgUrl: projImg1,
    },
  ];

  return (
<section className="project" id="projects">
  <div className="container">
    <Row>
      <Col size={12}>
        <TrackVisibility>
          <div style={{ textAlign: "center", marginBottom: "2rem" }}>
            <h2>Projects</h2>
            <p>
              Showcasing a collection of projects demonstrating my skills in software
              development, desktop and web applications, and AI-powered solutions.
            </p>

            <a
              href="https://github.com/duhankosali"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button 
                className="project-btn"
                type="button"
                style={{
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                View All Projects <ArrowRightCircle size={25} className="arrow-icon" />
              </button>
            </a>
          </div>

            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Tab.Content id="slideInUp">
                <Tab.Pane eventKey="first">
                  <Row>
                    {projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
        </TrackVisibility>
      </Col>
    </Row>
  </div>

</section>

  )
}
